export default "__VITE_ASSET__CB9UlT$w__"